import { configEnv } from '@/shared/config-env';

export const projectName = configEnv.PROJECT_NAME;
export const projectNames = {
  MTI: 'mti',
  SF: 'synergy',
  MOSAP: 'mosap',
  PEOPLE: 'people',
};

export const projectIds: Record<string, number> = {
  synergy: 1,
  mti: 5,
  mosap: 6,
};
export const projectId: number = projectIds[projectName as string] ?? Infinity;

export const STATUS_NOT_AUTH = 401;
export const REQUEST_ID_KEY = 'X-Request-ID';

export const projectIdByName = (name: string) => {
  return projectIds[name] ?? 1;
};
